import { el } from '../../core/dom.js';
import { withProduct } from '../../core/route-map.js';
import {
  cadenceWord, clip, clockOf, errorText, pageOf, statusLine, tagsFor,
} from './model.js';

function cta(label, onClick) {
  return el('button', { type: 'button', class: 'sched-cta', onClick },
    label,
    el('span', { class: 'sched-arw', 'aria-hidden': 'true' }, '→'));
}

export function renderHeader(productName, onCreate) {
  const name = productName || 'this product';
  return el('header', { class: 'sched-head' },
    el('div', { class: 'sched-head-copy' },
      el('h1', { class: 'sched-title' }, 'Reports that ', el('em', {}, 'arrive on time.')),
      el('p', {}, `Recurring reports for ${name}. Each run can email the answer and save it into Documents.`)),
    cta('New Schedule', onCreate));
}

function step(kicker, body) {
  return el('div', { class: 'sched-step' },
    el('span', { class: 'sched-step-kicker' }, kicker),
    el('p', {}, body));
}

export function renderSteps(productId) {
  const href = withProduct('/app/knowledge?tab=documents', productId);
  const docs = el('span', {}, 'Email, plus a copy in ', el('a', { href }, 'Documents'), '.');
  return el('section', { class: 'sched-steps', 'aria-label': 'How schedules work' },
    step('01 — Ask once', 'Any chat question can become a schedule.'),
    step('02 — Pick a time', 'Bonnie re-runs it against live sources.'),
    step('03 — Read it anywhere', docs));
}

export function renderEmpty(productName, onCreate) {
  const name = productName || 'this product';
  return el('div', { class: 'sched-empty' },
    el('p', { class: 'kicker' }, 'Nothing here'),
    el('h2', {}, 'No schedules yet'),
    el('p', {}, `Pick a question and a time. Bonnie runs it for ${name}, can email the answer, and saves a copy in Documents.`),
    cta('New Schedule', onCreate));
}

function renderCard(row, handlers) {
  const on = row.enabled !== false;
  const title = String(row.prompt || '').trim() || 'Scheduled report';
  const err = errorText(row.last_error);
  const busy = handlers.busyId === row.id;
  return el('article', {
    class: on ? 'sched-card is-on' : 'sched-card is-off',
    'aria-busy': busy ? 'true' : null,
  },
  el('div', { class: 'sched-clock' },
    el('span', { class: 'sched-time' }, clockOf(row.run_time)),
    el('span', { class: 'sched-cadence' }, cadenceWord(row.cadence))),
  el('div', { class: 'sched-copy' },
    el('h2', { class: 'sched-prompt' }, title),
    el('div', { class: 'sched-tags' }, tagsFor(row).map((tag) => el('span', { class: 'sched-tag' }, tag)))),
  el('div', { class: 'sched-status' },
    el('span', { class: 'sched-kicker' }, 'Status'),
    el('span', { class: on ? 'sched-status-line' : 'sched-status-line is-muted' },
      on ? el('span', { class: 'sched-pulse', 'aria-hidden': 'true' }) : null,
      statusLine(row)),
    err ? el('p', { class: 'sched-err' }, err) : null),
  el('div', { class: 'sched-actions' },
    el('button', {
      type: 'button',
      class: 'sched-details',
      onClick: () => handlers.onEdit(row),
    }, 'Details ', el('span', { class: 'sched-arw', 'aria-hidden': 'true' }, '→')),
    el('button', {
      type: 'button',
      class: on ? 'sched-switch is-on' : 'sched-switch',
      role: 'switch',
      'aria-checked': on ? 'true' : 'false',
      'aria-label': `${on ? 'Pause' : 'Resume'}: ${clip(title, 80)}`,
      disabled: busy ? true : null,
      onClick: () => handlers.onToggle(row),
    }, el('span', { class: 'sched-knob', 'aria-hidden': 'true' }))));
}

export function renderList(state, handlers) {
  const page = pageOf(state.rows, state.shown);
  return el('div', { class: 'sched-stack' },
    el('section', { class: 'sched-list', 'aria-label': 'Schedules' },
      page.rows.map((row) => renderCard(row, handlers)),
      page.more ? el('button', {
        type: 'button',
        class: 'sched-more',
        onClick: handlers.onMore,
      }, `Load more · ${page.remaining} left`) : null),
    renderSteps(state.opts.productId));
}
